import React from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
export function WhatYouGet() {
  const bullets = ['Cómo pasamos de abundancia a dependencia.', 'Qué intereses siempre estuvieron detrás.', 'Por qué no fue solo "mala suerte".', 'Qué patrones se repiten cuando un país pierde control de sus recursos.', 'Cómo reconocer las señales antes de que vuelvan a disfrazarse.'];
  return <div className="bg-dark-900 pb-0 md:pb-12" data-id="element-250">
      <Section data-id="element-251">
        <div className="max-w-4xl mx-auto" data-id="element-252">
          <div className="bg-dark-800 p-6 md:p-12 rounded-lg border border-gold-900/30 shadow-lg shadow-gold-900/5" data-id="element-253">
            <h3 className="text-3xl md:text-4xl font-serif font-bold text-white mb-3 text-center" data-id="element-254">
              Minerales de Sangre
            </h3>

            <p className="text-center text-cream-100 font-serif italic text-lg md:text-xl mb-8 md:mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-255">
              Memoria estratégica para el venezolano que no quiere ser
              manipulado.
            </p>

            <p className="mb-6 md:mb-8 text-cream-200 text-base md:text-lg" data-id="element-256">
              Este eBook conecta lo que muchos sentimos pero nunca vimos
              organizado:
            </p>

            <ul className="space-y-4 md:space-y-5 mb-8 md:mb-10" data-id="element-257">
              {bullets.map((item, i) => <motion.li key={i} initial={{
              opacity: 0,
              x: -15
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: i * 0.1
            }} className="flex items-start text-cream-100" data-id="element-258">
                  <span className="w-2 h-2 rounded-full bg-gold-500 mt-2.5 mr-4 flex-shrink-0" data-id="element-259" />
                  <span className="text-cream-200 text-base md:text-lg leading-relaxed" data-id="element-260">
                    {item}
                  </span>
                </motion.li>)}
            </ul>

            <div className="bg-dark-900/50 p-4 md:p-6 rounded border-l-4 text-center" style={{
            borderColor: '#dc2626'
          }} data-id="element-261">
              <p className="text-cream-300 mb-2" data-id="element-262">
                No te estoy prometiendo que "cambiarás el mundo".
              </p>
              <p className="text-cream-100 font-bold text-lg" data-id="element-263">
                Te estoy prometiendo algo más valioso en la vida real: que no te
                vuelvan a mover con cuentos fáciles.
              </p>
            </div>
          </div>
        </div>
      </Section>
    </div>;
}